function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.418 19.436a1.25 1.25 0 011.164 0l4.382 2.304c.917.482 1.989-.297 1.814-1.318l-.837-4.88a1.25 1.25 0 01.36-1.107l3.545-3.456c.742-.723.332-1.983-.693-2.132l-4.9-.712a1.25 1.25 0 01-.94-.683l-2.192-4.44c-.459-.93-1.783-.93-2.242 0l-2.191 4.44a1.25 1.25 0 01-.941.683l-4.9.712c-1.025.15-1.435 1.41-.693 2.133L5.7 14.434c.294.288.429.701.36 1.107l-.838 4.88c-.175 1.021.897 1.8 1.814 1.318l4.382-2.304zm.815-2.443a.5.5 0 00-.466 0l-3.42 1.798a.5.5 0 01-.725-.527l.653-3.809a.5.5 0 00-.144-.443l-2.767-2.697a.5.5 0 01.277-.853l3.824-.555a.5.5 0 00.376-.274l1.71-3.465a.5.5 0 01.897 0l1.71 3.465a.5.5 0 00.377.274l3.824.555a.5.5 0 01.277.853l-2.767 2.697a.5.5 0 00-.144.443l.653 3.809a.5.5 0 01-.725.527l-3.42-1.798z",
  fill: "#000"
});

function SvgStar(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref);
}

export default SvgStar;